import { registerDecorators as _registerDecorators, LightningElement, registerComponent as _registerComponent } from "lwc";
import _tmpl from "./error.html";
import { WireI18n } from '~/modules/stores/i18nStore';
import { images } from '~/modules/utilities/assetUtilities';
class ErrorComponent extends LightningElement {
  constructor(...args) {
    super(...args);
    this.titleLabel = void 0;
    this.descriptionLabel = void 0;
    this.buttonLabel = void 0;
    this.handleButtonClick = undefined;
    this.image = void 0;
    this.imageAltText = void 0;
    this.labels = void 0;
  }
  get errorImage() {
    return this.image || images.errorBird;
  }
  get errorTitle() {
    return this.titleLabel || this.labels?.title;
  }
  get errorDescription() {
    return this.descriptionLabel || this.labels?.description;
  }
  get errorButton() {
    return this.buttonLabel || this.labels?.button;
  }
  get altText() {
    return this.image || this.labels?.altText;
  }
  get shouldShowButton() {
    return this.handleButtonClick !== undefined;
  }
  /*LWC compiler v7.1.3*/
}
_registerDecorators(ErrorComponent, {
  publicProps: {
    titleLabel: {
      config: 0
    },
    descriptionLabel: {
      config: 0
    },
    buttonLabel: {
      config: 0
    },
    handleButtonClick: {
      config: 0
    },
    image: {
      config: 0
    },
    imageAltText: {
      config: 0
    }
  },
  wire: {
    labels: {
      adapter: WireI18n,
      dynamic: [],
      config: function ($cmp) {
        return {
          selector: i18n => i18n.error.shared
        };
      }
    }
  }
});
const __lwc_component_class_internal = _registerComponent(ErrorComponent, {
  tmpl: _tmpl,
  sel: "",
  apiVersion: 62
});
export default __lwc_component_class_internal;